import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 200rem)',
  flex: 1,
  gap: '16rem',
});

export const MapContainer = styled.div({
  position: 'relative',
  flex: 1,
  width: '100%',
  minHeight: '290rem',
  marginTop: '50rem',
});
